<script>
import MileCountdown from '@components/mile-countdown-2025.vue'
export default {
  page: {
    title: 'Mile Countdown 2025',
  },
  components: {
    MileCountdown,
  },
  data() {
    return {}
  },
  methods: {},
}
</script>

<template>
  <div>
    <div :class="$style.container"> <MileCountdown :height="300" /></div>
    <div :class="$style.container2"> <MileCountdown :height="150" /></div>
    <div :class="$style.container3"> <MileCountdown :height="78" /></div>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.container {
  width: 1200px;
  height: 300px;
}

.container2 {
  width: 600px;
  height: 150px;
}

.container3 {
  width: 312px;
  height: 78px;
}
</style>
